import {
  IonContent,
  IonItem,
  IonList,
  IonLoading,
  IonPage,
} from '@ionic/react';
import _ from 'lodash';
import React from 'react';

import { Text } from '~/components/defaultUIComponents';
import EinmalAuftragTile from '../components/EinmalAuftragTile';
import Toolbar from '../components/Toolbar/Toolbar';
import { useTranslate } from '~/i18n/translate';
import { useEinmalAuftraege } from '~/api/EinmalAuftragApi';

const EinmalAuftraege: React.FC = () => {
  const translate = useTranslate();
  const { data: einmalAuftraege, isLoading } = useEinmalAuftraege();

  return (
    <IonPage>
      <Toolbar>{translate('einmalAuftraege.toolbar')}</Toolbar>
      <IonContent>
        <IonLoading isOpen={isLoading} />
        {einmalAuftraege && einmalAuftraege.length > 0 ? (
          <IonList>
            {_.orderBy(einmalAuftraege, 'priority').map((einmalAuftrag) => (
              <EinmalAuftragTile
                key={einmalAuftrag.id}
                einmalAuftrag={einmalAuftrag}
                isStartable
              />
            ))}
          </IonList>
        ) : (
          <IonItem lines="none">
            <Text textSize="xl">{translate('einmalAuftraege.empty')}</Text>
          </IonItem>
        )}
      </IonContent>
    </IonPage>
  );
};

export default EinmalAuftraege;
